import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Icon, iconProps } from '@zambezi/sdk/common'

/**
 * Create a header for the Accordion.
 *
 * @param {import('./interfaces').HeaderProps} props
 * @param {import('react').RefObject} ref
 * @returns {JSX.Element}
 */
function header ({ id, open, children, iconProps, ...rest }, ref) {
  const headerProps = {
    ...rest,
    role: 'button',
    'aria-expanded': open,
    tabIndex: 0,
    ref
  }
  return (
    <dt id={id}>
      <div {...headerProps}>
        <Icon
          aria-hidden
          title={open ? 'Collapse' : 'Expand'}
          className='zb-accordion-header-icon'
          name={open ? 'core-accordion-collapse' : 'core-accordion-expand'}
          size='small'
          iconProps={iconProps}
        />
        {children}
      </div>
    </dt>
  )
}

const Header = forwardRef(header)

Header.displayName = 'Header'
Header.defaultProps = {
  onKeyDown: () => {}
}
Header.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  open: PropTypes.bool,
  children: PropTypes.node,
  'aria-controls': PropTypes.string,
  iconProps
}

export default Header
